<template>
  <v-snackbar
    :value="visible"
    :color="type"
    :timeout="time"
    top
  >
    {{ text }}
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    time: 0,
  }),
  computed: {
    ...mapGetters({
      text: 'notifications/message',
      type: 'notifications/type',
      visibleFromStore: 'notifications/visible',
    }),
    visible: {
      get() {
        return this.visibleFromStore;
      },
      set(visible) {
        return visible;
      },
    },

  },
};
</script>
